<template>
  <v-select
    :disabled="disabled"
    :class="classObjectContainer"
    :value="selected"
    :label="label"
    :reduce="_reduce"
    @input="handleInput"
    @option:selected="_selected"
    :options="options"
    clearSearchOnSelect
    v-if="ready"
  >
    <template v-slot:option="option">
      <slot name="option" :option="option">
        {{ option[label] }}
      </slot>
    </template>
  </v-select>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  name: "V2Select",
  props: {
    value: {
      type: [String, Object],
      default: ""
    },
    size: {
      type: String,
      default: "normal"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "text"
    },
    _reduce: {
      type: Function,
      default: (e) => e
    },
    _selected: {
      type: Function,
      default: () => {}
    },
    options: {
      type: Array,
      default: () => [{ text: "Seleccione", value: null }]
    }
  },
  data() {
    return {
      ready: false,
      selected: this.value,
      submitActive: false
    };
  },
  computed: {
    classObjectContainer: function () {
      return {
        "form-control": true,
        "style-chooser": true,
        "form-control-sm": this.size === "small",
        "is-valid": this.selected != null && this.$v.selected.$dirty == true ? true : false,
        "is-invalid":
          this.selected == null && (this.$v.selected.$dirty == true || this.submitActive == true) ? true : false
      };
    }
  },
  watch: {
    value: function (val) {
      this.selected = val;
      this.$v.$touch();
    }
  },
  methods: {
    hendleSelected(e) {
      console.log(e);
    },
    handleInput(val) {
      this.$emit("input", val);
    }
  },
  validations: {
    selected: { required }
  },
  mounted() {
    this.ready = true;
  }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  min-height: calc(1.5em + 0.75rem + 2px);
  font-size: 0.6rem;
  font-weight: 400;
  color: #5c6873;
  border: none;
  margin-top: -7px;
  margin-left: 0px;
}
.style-chooser {
  background: none;
}
/* .vs__dropdown-menu {
  border: solid 1px red;
} */
.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
  display: none;
}
</style>
